
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_1akgb_9",
  "root-horizontal": "awsui_root-horizontal_o08jm_1akgb_41",
  "root-vertical": "awsui_root-vertical_o08jm_1akgb_46",
  "control": "awsui_control_o08jm_1akgb_51",
  "control-middle-horizontal": "awsui_control-middle-horizontal_o08jm_1akgb_58",
  "control-last-horizontal": "awsui_control-last-horizontal_o08jm_1akgb_58",
  "control-middle-vertical": "awsui_control-middle-vertical_o08jm_1akgb_61",
  "control-last-vertical": "awsui_control-last-vertical_o08jm_1akgb_61",
  "inline-label": "awsui_inline-label_o08jm_1akgb_65",
  "inline-label-wrapper": "awsui_inline-label-wrapper_o08jm_1akgb_90",
  "inline-label-trigger-wrapper": "awsui_inline-label-trigger-wrapper_o08jm_1akgb_95"
};
  